import { render } from "./FacebookLeads.vue?vue&type=template&id=626320b4"
import script from "./FacebookLeads.vue?vue&type=script&lang=js"
export * from "./FacebookLeads.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cms.dealersgear.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__